'use strict';

require('project/crud/crud.less');

let env = require('shared/scripts/env');

require('shared/scripts/angular-frontend-webpack-index-html-deps');

require('angular-scroll');
require('bower_components/ng-videosharing-embed/build/ng-videosharing-embed.min.js');

require('bower_components/angular-resource/angular-resource.js');

let app = angular
    .module('app', [
        require('shared/scripts/angular-frontend').default.name,
        (() => { // optimizely
            require('ng-optimizely');
            return 'ng-optimizely'
        })(),
        'duScroll',
        'videosharing-embed',
        'ngResource',                   // $resource
        /**
         * App uses AngularUI Router to manage routing and views
         * Each view is defined as state.
         */
        require('project/scripts/app.routing').name,
        require('project/scripts/data-environment-specific/data-environment-specific.routing').name,
        require('project/sections/0-onboarding/onboarding.routing').name,
        require('project/sections/1-owner/owner.routing').name,
        require('project/sections/2-time/time.routing').name,
        require('project/sections/3-basics/basics.routing').name,
        require('project/sections/4-owner-compensation/owner-compensation.routing').name,
        require('project/sections/5-vat/vat.routing').name,
        require('project/sections/6-books/books.routing').name,
        require('project/sections/7-missions/missions.routing').name,
        require('project/sections/8-share/share.routing').name,
        require('project/sections/outsource/outsource.routing').name,
        require('project/sections/assist/assist.routing').name,
        require('project/sections/help/help.routing').name,
        require('project/sections/debug/debug.routing').name,
    ]);

let optimizelyFallbackData = require('./optimizely-fallback-data.js');

require('./app.ng-includes.js');
require('./app.restrictUi.js');

require('components/clock/clock');
require('components/onboarding/react-components');
require('components/onboarding/angular-components');
require('components/action-list-items/angular-components');
require('components/section-headers/angular-components');

// Debug state transitions
//app.run(function($trace) { $trace.enable('TRANSITION', "VIEWCONFIG"); })

app

/**
 * Service to handle data-change suggestions via the angular ui
 */
    .service('backendOperations', function ($http, $location, $injector, contentFilters, activeItems) {

        var statuses = {
            PREVIEW: 'preview',
            INACTIVE: 'inactive',
            LOADING: 'loading',
            ERROR: 'error'
        };

        var status = statuses.INACTIVE;

        var backendOperations = {
            statuses: statuses,
            replacedResources: {
                collections: {},
                items: {}
            },
            activeSuggestions: [],
            suggest: function (suggestions, save) {

                console.log('backendOperations.suggest() - suggestions, save', suggestions, save);

                var self = this;

                _.each(suggestions, function (value, key, list) {
                    self.activeSuggestions.push(value);
                });

                self.query(save);

            },
            refresh: function () {

                console.log('backendOperations.refresh()');

                var self = this;

                self.query(false, true);

            },
            submit: function () {

                console.log('backendOperations.submit()');

                var self = this;

                self.query(true);

            },
            query: function (save, refresh) {

                console.log('backendOperations.query() - save', save);

                var self = this;

                var params = angular.extend({}, {
                    'suggestions': self.activeSuggestions,
                    'save': save,
                    'filters': contentFilters.all(),
                    'activeItemIds': activeItems.activeItemIds(),
                    'refresh': refresh,
                    'default_page': 1,
                    'default_limit': 100
                });

                status = statuses.LOADING;
                $http.post(env.API_BASE_URL + '/' + env.API_VERSION + '/operations', params).then(function (response) {
                    // this callback will be called asynchronously
                    // when the response is available

                    console.log('suggestions received', response);

                    _.each(response.data.collections, function (value, key, list) {

                        $injector.invoke([key, function (singletonCollection) {

                            // If first suggestions-query, store previously used data for easy reset
                            if (!self.replacedResources.collections[key]) {
                                self.replacedResources.collections[key] = angular.copy(singletonCollection);
                                self.replacedResources.collections[key].$metadata = angular.copy(singletonCollection.$metadata);
                            }

                            // Replace with returned data
                            singletonCollection.replace(value.items);
                            singletonCollection.$metadata = value._meta;
                            singletonCollection.$resolved = true;
                            singletonCollection.$activated = true;

                        }]);

                    });

                    _.each(response.data.items, function (value, key, list) {

                        $injector.invoke([key, function (singletonItem) {

                            // If first suggestions-query, store previously used data for easy reset
                            if (!self.replacedResources.items[key]) {
                                self.replacedResources.items[key] = angular.copy(singletonItem);
                            }

                            // Replace with returned data
                            singletonItem.replace(value);
                            singletonItem.$resolved = true;
                            singletonItem.$activated = true;

                        }]);

                    });

                    if (save) {
                        self.activeSuggestions = [];
                        self.replacedResources = {
                            collections: {},
                            items: {}
                        };
                        status = statuses.INACTIVE;
                    } else {
                        status = statuses.PREVIEW;
                    }

                }, function (response) {
                    // called asynchronously if an error occurs
                    // or server returns response with an error status.

                    status = statuses.ERROR;
                    console.log('error during suggestions received', response);

                });

            },
            status: function () {
                return status;
            },
            restore: function () {

                var self = this;

                self.activeSuggestions = [];

                _.each(self.replacedResources.collections, function (value, key, list) {

                    $injector.invoke([key, function (resource) {

                        // Restore previously used data
                        resource.replace(value);
                        resource.$metadata = value.$metadata;
                        delete self.replacedResources.collections[key];

                    }]);

                });
                _.each(self.replacedResources.items, function (value, key, list) {

                    $injector.invoke([key, function (resource) {

                        // Restore previously used data
                        resource.replace(value);
                        resource.$metadata = value.$metadata;
                        delete self.replacedResources.items[key];

                    }]);

                });
                status = statuses.INACTIVE;

            }
        };

        return backendOperations;

    })

    /**
     * Service used to hold information about route-based content filters, such as when visiting an item's page, only show items related to that item
     */
    .service('routeBasedContentFilters', function () {

        return {};

    })

    /**
     * Service to extract information about current content filters
     * Content filters are stored in $state.params (prefixed with cf_) and the service routeBasedContentFilters
     */
    .service('contentFilters', function ($state, routeBasedContentFilters) {

        return {
            all: function () {

                var stateBasedContentFilters = this.stateBasedContentFilters();
                var allContentFilters = angular.merge({}, stateBasedContentFilters, routeBasedContentFilters);
                return allContentFilters;

            },
            stateBasedContentFilters: function () {

                // Filter by cf_ namespace
                var stateBasedContentFilters = _.reduce($state.params, function (obj, val, key) {
                    if (key.indexOf("cf_") === 0) {
                        obj[key.replace("cf_", "")] = val;
                    }
                    return obj;
                }, {});

                return stateBasedContentFilters;

            },
            narrowDownToItemTypeSpecific: function (itemType, contentFiltersToNarrowDown) {

                // Filter on item type by item type namespace
                return _.reduce(contentFiltersToNarrowDown, function (obj, val, key) {
                    if (key.indexOf(itemType + "_") === 0) {
                        obj[key] = val;
                    }
                    return obj;
                }, {});

            },
            itemTypeSpecific: function (itemType) {

                var allContentFilters = this.all();
                return this.narrowDownToItemTypeSpecific(itemType, allContentFilters);

            },
            itemTypeSpecificStateBasedContentFilters: function (itemType) {

                var stateBasedContentFilters = this.stateBasedContentFilters();
                return this.narrowDownToItemTypeSpecific(itemType, stateBasedContentFilters);

            },
            // Legacy wrapper
            itemTypeSpecificLocationBasedContentFilters: function (itemType) {

                return this.itemTypeSpecificStateBasedContentFilters(itemType);

            },
            trueIfNonEmpty: function (filter) {
                return !angular.equals(filter, {});
            }

        };

    })

    /**
     * Service to extract information about active items
     * Active items are stored in $state.params prefixed with "active"
     */
    .service('activeItems', function ($state) {

        return {

            activeItemIds: function () {

                var activeItemIds = _.reduce($state.params, function (obj, val, key) {
                    if (key.indexOf("active") === 0) {
                        obj[key.replace("active", "")] = val;
                    }
                    return obj;
                }, {});
                return activeItemIds;

            },

        };

    })

    /**
     * Service used to hold information about route-based visibility settings, such as when visiting a specific curate step, only show columns relevant to that step
     */
    .service('routeBasedVisibilitySettings', function () {

        return {};

    })

    /**
     * Service to extract information about current visibility settings
     * Content visibility settings are stored in $location.search (prefixed with vs_) and the service routeBasedVisibilitySettings
     */
    .service('visibilitySettings', function ($location, routeBasedVisibilitySettings) {

        var visibilitySettings = {
            all: function () {

                // Filter by vs_ namespace
                var locationBasedVisibilitySettings = _.reduce($location.search(), function (obj, val, key) {
                    if (key.indexOf("vs_") === 0) {
                        obj[key.replace("vs_", "")] = val;
                    }
                    return obj;
                }, {});

                var allVisibilitySettings = angular.merge({}, locationBasedVisibilitySettings, routeBasedVisibilitySettings);

                return allVisibilitySettings;

            },
            itemTypeSpecific: function (itemType) {

                var allVisibilitySettings = this.all();

                // Filter on item type by item type namespace
                return _.reduce(allVisibilitySettings, function (obj, val, key) {
                    if (key.indexOf(itemType + "_") === 0) {
                        obj[key] = val;
                    }
                    return obj;
                }, {});

            }
        };

        return visibilitySettings;

    })

    /**
     * Service used to access data resolved via the deferred object window.optimizelyVariation
     * This way, optimizely scripts can resolve window.optimizelyVariation in order to make that data accessible to angular templates:
     * window.optimizelyVariation.resolve(data);
     */
    .service('optimizelyVariation', function (optimizely, optimizelyFallbackData, $window, $timeout) {

        console.log('optimizely variation data service init');
        var optimizelyVariation = {
            data: null,
            deferred: $window.optimizelyVariationDeferred
        };
        optimizelyVariation.deferred.done(function (data) {
            console.log('optimizely variation data deferred done');
            optimizelyVariation.data = data;
            // inform angular that we have updated the data by implicitly calling $apply via $timeout
            $timeout(function () {
                console.log('optimizely data in place');
            });
        });

        // Tmp use fallback always for now, so that it is easy to test different data locally
        optimizelyVariation.deferred.resolve(optimizelyFallbackData);
        return optimizelyVariation;

        // Use fallback data if working offline or optimizely has not delivered the data within a certain timeframe
        if (env.OFFLINE_DEV === 'true') {
            optimizelyVariation.deferred.resolve(optimizelyFallbackData);
        } else {
            optimizely.loadProject();
            // Allow some time for optimizely data to arrive
            $timeout(function () {
                console.log('$timeout optimizely timeout');
                optimizelyVariation.deferred.resolve(optimizelyFallbackData);
            }, 2000);
        }

        return optimizelyVariation;

    })

    /**
     * Allows to render HTML via scope variables
     * Source: http://stackoverflow.com/a/25513186/682317
     */
    .filter("sanitize", ['$sce', function ($sce) {
        return function (htmlCode) {
            return $sce.trustAsHtml(htmlCode);
        }
    }])

    /**
     * Add the DATA header to API requests 0 Friendly logging of unauthorized requests
     */
    .factory('authInterceptor', function ($log, $q, activeDataEnvironment) {
        return {
            request: function (config) {
                config.headers = config.headers || {};
                // Supply header indicating which data profile we should use for the request
                if (activeDataEnvironment.available && config.url.indexOf(env.API_BASE_URL) > -1) {
                    config.headers['X-Data-Profile'] = env.DATA || 'clean-db';
                }
                //config.withCredentials = true;
                return config;
            },
            responseError: function (response) {
                if (response.status === 401) {
                    // handle the case where the user is not authenticated
                    $log.warn('unauthorized request intercepted by authInterceptor');
                }
                if (response.status === 403) {
                    // handle the case where the user is not authorized
                    $log.warn('forbidden request intercepted by authInterceptor');
                }
                return $q.reject(response);
            },
        };
    })
    .config(function ($httpProvider) {
        $httpProvider.interceptors.push('authInterceptor');
    })

    /**
     * Display backend errors in frontend
     */
    .factory('exceptionInterceptor', function ($log, $q, debugService) {
        return {
            responseError: function (response) {

                // TODO: Only show and exception popup if the error came from our own servers
                console.log('TODO: Only show and exception popup if the error came from our own servers', response);

                if (response.status === 500) {
                    debugService.renderException(response.data);
                }

                return $q.reject(response);
            }
        };
    })
    .config(function ($httpProvider) {
        $httpProvider.interceptors.push('exceptionInterceptor');
    })
    .service('debugService', function ($log, $injector) {
        this.renderException = function (data) {
            return $injector.get('$modal').open({
                template: require('modals/debug.html'),
                controller: 'DebugController',
                size: "lg",
                resolve: {
                    data: function () {
                        return data;
                    }
                }
            });
        };
    })
    .controller('DebugController', function ($log, $scope, data, $modalInstance) {
        $scope.data = data;

        $scope.close = function () {
            $modalInstance.dismiss();
        };
    })

    // http://stackoverflow.com/a/24519069/682317
    .filter('trusted', ['$sce', function ($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    }])

    // http://stackoverflow.com/a/25344423/682317
    .directive('emptyToNull', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                ctrl.$parsers.push(function (viewValue) {
                    if (viewValue === "") {
                        return null;
                    }
                    return viewValue;
                });
            }
        };
    })

export default app;



// WEBPACK FOOTER //
// .-dna/app/scripts/app.js